<div class="h-full flex flex-col overflow-hidden md:flex-row">
  <div class="bg-black w-full md:max-w-[220px] md:min-w-[220px] md:h-full">
    <app-navigation />
  </div>
  <div class="h-full overflow-y-auto flex-grow">
    <app-toolbar />
    <div class="p-4 md:p-8">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
